var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-info",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,15.4c-0.6,0-1-0.4-1-1v-3.6c0-0.6,0.4-1,1-1s1,0.4,1,1v3.6C11.5,15,11.1,15.4,10.5,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,7.6c-0.3,0-0.5-0.1-0.7-0.3C9.7,7.2,9.6,7.1,9.6,7c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0.1-0.4 c0.1-0.1,0.1-0.2,0.2-0.3c0.4-0.4,1-0.4,1.4,0c0.2,0.2,0.3,0.5,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7C11,7.5,10.8,7.6,10.5,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0.5c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10C20.5,5,16,0.5,10.5,0.5z M10.5,18.5 c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.9,18.5,10.5,18.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5e60585c21fb2264cb70c41b9f1947af.svg";
export { ForwardRef as ReactComponent };